export default __webpack_public_path__ + "static/media/payroll.d1e66203.svg";